import { configureStore } from "@reduxjs/toolkit";

import axiosMiddleware from "../middlewares/axiosMiddleware";
import authReducer from "./authSlice";
import userReducer from "./userSlice";
import toastReducer from "./toastSlice";
import languageReducer from "./languageSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    toast: toastReducer,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(axiosMiddleware),
});

export default store;
